import { TinyTooltip } from './Tooltip';
import React, { Component } from 'react';
import ModalWait from './ModalWait';
import Modal from './Modal';
import { PRICING_OPTIONS } from '../helpers/constants';
import { REVIEW_COLORS } from '../helpers/constants';
import axios from 'axios';
import { formatCurrency, getPropertyType } from '../helpers/utils';
import LoginState from './LoginState';
import { withRouter } from 'react-router-dom';

class Circumstance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileID: this.props.match.params.id,
      retrievedData: false,
      changesExist: false,
      circumstanceData: [],
      changesRequested: [],
      searchLog: [],
      newFeeRows: 0,
      showFees: true,
      showConfirmModal: false,
      sentNotifications: false,
      showDenied: false,
      notificationError: false,
      errors: {},
    };
  }

  async GetSearchLog(fileID) {
    // now update server with this data
    const response = axios.get('/getUpdatedSearchLog', {
      params: {
        pFileID: fileID,
        pUserID: LoginState.userId,
      },
    });
    var resultData = (await response).data;
    this.setState({ searchLog: resultData });
  }

  PageLoad(fileID) {
    this.setState({
      fileID: fileID,
      circumstanceData: [],
      changesRequested: [],
      retrievedData: false,
    });
    this.GetSearchLog(fileID);
    this.FetchCircumstanceDataFromServer(fileID);
  }

  componentDidMount() {
    this.PageLoad(this.props.match.params.id);
  }

  FetchCircumstanceDataFromServer = async fileID => {
    axios
      .get('/getcircumstances', {
        params: {
          pFileID: fileID,
        },
      })
      .then(res => {
        if ('data' in res) {
          this.setState({
            retrievedData: true,
            circumstanceData: res.data,
          });
        }
      })
      .catch(e => console.log(e, 'Error fetching circumstances data'));
  };

  AddFeeRow() {
    this.setState({ newFeeRows: this.state.newFeeRows + 1 });
  }

  RemoveFeeRow(index) {
    const lastIndex = this.state.newFeeRows;

    for (var i = index; i < lastIndex; i++) {
      this.setState({
        ['newFeeDesc' + i]: this.state['newFeeDesc' + (i + 1)] ?? '',
        ['newFeeAmt' + i]: this.state['newFeeAmt' + (i + 1)] ?? '',
      });
    }
    // last row
    this.setState({
      ['newFeeDesc' + (lastIndex - 1)]: '',
      ['newFeeAmt' + (lastIndex - 1)]: '',
      newFeeRows: this.state.newFeeRows - 1,
    });
  }

  GetLabel(index, array) {
    if (index === -1 || !array || array.length <= index || !array[index])
      return '---';
    else return array[index].label;
  }

  GetOccupancyType() {
    try {
      return PRICING_OPTIONS.occupancyType[
        parseInt(this.state.circumstanceData.occupancyType) - 1
      ].label;
    } catch {
      return '---';
    }
  }

  GetPropertyType() {
    var unitCount = parseInt(this.state.circumstanceData.numberOfUnits);
    if (unitCount > 1) {
      return unitCount + ' Unit';
    }
    return getPropertyType(this.state.circumstanceData.propertyType);
  }

  /*
   * Capture any inputs value, save it in state
   */
  captureInput = e => {
    let newVal = e.target.value;
    if (this.state.errors) {
      let errors = { ...this.state.errors };
      delete errors[e.target.id];
      this.setState({
        [e.target.id]: newVal,
        changesExist: true,
        errors,
      });
    } else {
      this.setState({
        [e.target.id]: newVal,
        changesExist: true,
      });
    }
  };

  captureInputCurrency = e => {
    let newVal = e.target.value;
    let stripped = Number(
      newVal.toString().replace('$', '').replaceAll(',', '')
    );

    // format as currency
    if (!isNaN(stripped) && newVal.length > 0 && newVal.slice(-1) !== '.') {
      var temp = newVal.slice(-3);
      newVal =
        '$' +
        stripped.toLocaleString('en-US') +
        (newVal.slice(-2) === '.0' ? '.0' : '') +
        (newVal.slice(-3) === '.00' ? '.00' : '');
      if (
        temp.length === 3 &&
        temp[0] === '.' &&
        temp[1] !== '0' &&
        temp[2] === '0'
      )
        newVal = newVal + '0';
    }

    if (this.state.errors) {
      let errors = { ...this.state.errors };
      delete errors[e.target.id];
      this.setState({
        [e.target.id]: newVal,
        changesExist: true,
        errors,
      });
    } else {
      this.setState({
        [e.target.id]: newVal,
        changesExist: true,
      });
    }
  };

  ShowConfirmModal() {
    return (
      <div>
        {this.state.changesRequested.map(change => (
          <div key={change}>
            <p>{change.condition}</p>
            <div className="table-responsive">
              <table className="table">
                <tbody>
                  <tr>
                    <td width="10px" />
                    <td width="190px">{change.old}</td>
                    <td width="30px">
                      <i className="bi bi-arrow-right text-success" />
                    </td>
                    <td width="190px">{change.new}</td>
                    <td width="10px" />
                    <td width="190px" style={{ color: 'red' }}>
                      {this.GetLabel(
                        parseInt(change.reason) - 1,
                        PRICING_OPTIONS.cocReasons
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    );
  }

  async UpdateCircumstance(requestDate, status, changeRequested, role) {
    var response = axios.get('/getcircumstancenotifications', {
      params: {
        pUserID: LoginState.userId,
        pfileDataID: this.state.fileID,
        pRequestDate: requestDate,
        pStatus: status,
        pChangeRequested: changeRequested,
        pUserName: LoginState.userName,
        pRole: role,
      },
    });

    try {
      await response;
      this.ClearFields();
      this.FetchCircumstanceDataFromServer(this.props.match.params.id);
    } catch {
      this.setState({
        retrievedData: true,
        retrievedTab: this.state.activeTab,
        notificationData: [],
      });
    }
  }

  async SendChangeNotifications() {
    // clear first
    this.setState({ showConfirmModal: false, isUploading: true });

    var changesToNotify = [];
    for (var i = 0; i < this.state.changesRequested.length; i++) {
      changesToNotify.push(this.state.changesRequested[i].condition);
      changesToNotify.push(this.state.changesRequested[i].old);
      changesToNotify.push(this.state.changesRequested[i].new);
      changesToNotify.push(
        this.GetLabel(
          parseInt(this.state.changesRequested[i].reason) - 1,
          PRICING_OPTIONS.cocReasons
        )
      );
    }

    var response = axios.get('/sendcocnotifications', {
      params: {
        pFileID: this.props.match.params.id,
        pChanges: changesToNotify.join('$$$$$'),
        pUserName: LoginState.userName,
      },
    });

    try {
      var resultData = (await response).data;
      if (resultData) {
        this.setState({
          sentNotifications: true,
          showConfirmModal: false,
          isUploading: false,
        });
        this.ClearFields();
        this.FetchCircumstanceDataFromServer(this.props.match.params.id);
      }
    } catch {
      this.setState({
        showConfirmModal: false,
        isUploading: false,
      });
    }
  }

  CheckAndSubmitFeeChanges() {
    var changeList = [];
    const errors = {};
    var i;

    for (i = 0; i < this.state.circumstanceData.feeData.length; i++) {
      if (!this.state.appraisedValueReason) {
        const feeID = this.state.circumstanceData.feeData[i].feeID;
        const feeField = this.state[feeID];
        if (feeField && !this.state[feeID + 'Reason'])
          errors[feeID + 'ReasonError'] = 'Reason Not Selected';
      }
    }

    // first handle the fees from the database
    for (i = 0; i < this.state.circumstanceData.feeData.length; i++) {
      const fee = this.state.circumstanceData.feeData[i];
      const feeNewAmt = this.state[fee.feeID];
      const feeOldAmt = parseFloat(fee.amount).toFixed(2);

      if (this.state['fee' + fee.feeID + 'CB'] || feeNewAmt) {
        changeList.push({
          condition: fee.description,
          old: formatCurrency(feeOldAmt),
          new:
            feeNewAmt +
            (this.state['fee' + fee.feeID + 'CB'] && feeNewAmt !== 'Request POC'
              ? ' (Request POC)'
              : ''),
          reason: this.state[fee.feeID + 'Reason'],
        });
      }
    }

    // if any errors render them in page
    if (Object.values(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    // then check for any new fees requested
    for (let i = 0; i < this.state.newFeeRows; i++) {
      const feeDesc = this.state['newFeeDesc' + i];
      const feeAmt = this.state['newFeeAmt' + i];
      const reqPOC = this.state['newFee' + i + 'CB'] ? ' (Request POC)' : '';
      if (feeDesc)
        changeList.push({
          condition: feeDesc,
          old: '(New Fee Request)',
          new: feeAmt + reqPOC,
          reason: 7,
        });
    }

    this.setState({
      errors,
      changesRequested: changeList,
      showConfirmModal: changeList.length > 0,
    });
  }

  CheckAndSubmitLoanInfoChanges() {
    var changeList = [];
    const errors = {};

    if (this.state.appraisedValue) {
      if (!this.state.appraisedValueReason) {
        errors.appraisedValueReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'Appraisal Value',
        old: this.state.circumstanceData.appraisedValue,
        new: this.state.appraisedValue,
        reason: this.state.appraisedValueReason,
      });
    }
    if (this.state.creditScore) {
      if (!this.state.creditScoreReason) {
        errors.creditScoreReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'Credit Score',
        old: this.state.circumstanceData.creditScore,
        new: this.state.creditScore,
        reason: this.state.creditScoreReason,
      });
    }
    if (this.state.impound) {
      if (!this.state.impoundReason) {
        errors.impoundReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'Escrow Account',
        old: this.GetLabel(
          this.state.circumstanceData.impound,
          PRICING_OPTIONS.impound
        ),
        new: this.GetLabel(this.state.impound - 1, PRICING_OPTIONS.impound),
        reason: this.state.impoundReason,
      });
    }
    if (this.state.loanAmount) {
      if (!this.state.loanAmountReason) {
        errors.loanAmountReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'Loan Amount',
        old: this.state.circumstanceData.loanAmount,
        new: this.state.loanAmount,
        reason: this.state.loanAmountReason,
      });
    }
    if (this.state.pmi && this.state.pmi > 0) {
      if (!this.state.pmiReason) {
        errors.pmiReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'Mortgage Insurance',
        old: this.GetLabel(
          this.state.circumstanceData.pmi,
          PRICING_OPTIONS.pmi
        ),
        new: this.GetLabel(this.state.pmi - 1, PRICING_OPTIONS.pmi),
        reason: this.state.pmiReason,
      });
    }
    if (this.state.occupancyType && this.state.occupancyType > 0) {
      if (!this.state.occupancyTypeReason) {
        errors.occupancyTypeReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'Occupancy Type',
        old: this.GetOccupancyType(),
        new: this.GetLabel(
          this.state.occupancyType - 1,
          PRICING_OPTIONS.occupancyType
        ),
        reason: this.state.occupancyTypeReason,
      });
    }
    if (this.state.loanProgram && this.state.loanProgram > 0) {
      var progName = '';
      for (var i = 0; i < this.state.circumstanceData.programs.length; i++) {
        if (
          this.state.circumstanceData.programs[i].value.toString() ===
          this.state.loanProgram.toString()
        ) {
          progName = this.state.circumstanceData.programs[i].label;
        }
      }
      if (progName !== this.state.circumstanceData.loanProgram) {
        if (!this.state.loanProgramReason) {
          errors.loanProgramReasonError = 'Reason Not Selected';
        }
        changeList.push({
          condition: 'Loan Program',
          old: this.state.circumstanceData.loanProgram,
          new: progName,
          reason: this.state.loanProgramReason,
        });
      }
    }
    if (
      this.state.propertyType &&
      this.state.propertyType > 0 &&
      PRICING_OPTIONS.propertyType[this.state.propertyType - 1].label !==
        this.GetPropertyType()
    ) {
      if (!this.state.propertyTypeReason) {
        errors.propertyTypeReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'Property Type',
        old: this.GetPropertyType(),
        new: this.GetLabel(
          this.state.propertyType - 1,
          PRICING_OPTIONS.propertyType
        ),
        reason: this.state.propertyTypeReason,
      });
    }
    if (
      this.state.loanPurpose &&
      this.state.loanPurpose > 0 &&
      parseInt(this.state.loanPurpose) - 1 !==
        parseInt(this.state.circumstanceData.loanPurpose)
    ) {
      if (!this.state.loanPurposeReason) {
        errors.loanPurposeReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'Loan Purpose',
        old: this.state.circumstanceData.loanPurpose,
        new: this.GetLabel(
          this.state.loanPurpose - 1,
          PRICING_OPTIONS.loanPurpose
        ),
        reason: this.state.loanPurposeReason,
      });
    }
    if (this.state.purchasePrice) {
      if (!this.state.purchasePriceReason) {
        errors.purchasePriceReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'Purchase Price',
        old: this.state.circumstanceData.purchasePrice,
        new: this.state.purchasePrice,
        reason: this.state.purchasePriceReason,
      });
    }

    if (this.state.lockDays && this.state.lockDays > 0) {
      if (!this.state.lockDaysReason) {
        errors.lockDaysReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'Lock Days',
        old: this.state.circumstanceData.lockDays !== "-1" ? PRICING_OPTIONS.lockPeriod[this.state.circumstanceData.lockDays].label : "---",
        new: this.GetLabel(
          this.state.lockDays - 1,
          PRICING_OPTIONS.lockPeriod
        ),
        reason: this.state.lockDaysReason,
      });
    }

    if (this.state.lockExtension && this.state.lockExtension > 0) {
      if (!this.state.lockExtensionReason) {
        errors.lockExtensionReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'Lock Extension',
        old: '---',
        new: this.GetLabel(
          this.state.lockExtension - 1,
          PRICING_OPTIONS.lockExtension
        ),
        reason: this.state.lockExtensionReason,
      });
    }

    if (this.state.pnlPreparer && this.state.pnlPreparer > 0) {
      if (!this.state.pnlPreparerReason) {
        errors.pnlPreparerReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'P&L Preparer',
        old: this.state.circumstanceData.pnlPreparer,
        new: this.GetLabel(
          this.state.pnlPreparer - 1,
          PRICING_OPTIONS.pnlPreparer
        ),
        reason: this.state.pnlPreparerReason,
      });
    }

    if (this.state.prepaymentPenalty && this.state.prepaymentPenalty > 0) {
      if (!this.state.prepaymentPenaltyReason) {
        errors.prepaymentPenaltyReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'Prepayment Penalty',
        old:
          this.state.circumstanceData.prepaymentPenalty === '---'
            ? 'No Prepay Penalty'
            : Number(this.state.circumstanceData.prepaymentPenalty) / 12 +
              '-Year Prepay Penalty',
        new: this.GetLabel(
          this.state.prepaymentPenalty - 1,
          PRICING_OPTIONS.prepayPenalty
        ),
        reason: this.state.prepaymentPenaltyReason,
      });
    }

    if (this.state.propertyAddress) {
      if (!this.state.propertyAddressReason) {
        errors.propertyAddressReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'Property Address',
        old: this.state.circumstanceData.propertyAddress,
        new: this.state.propertyAddress,
        reason: this.state.propertyAddressReason,
      });
    }
    if (this.state.borrowers) {
      if (!this.state.borrowersReason) {
        errors.borrowersReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'Add/Remove Borrower',
        old: this.state.circumstanceData.borrowers,
        new: this.state.borrowers,
        reason: this.state.borrowersReason,
      });
    }
    if (this.state.trust) {
      if (!this.state.trustReason) {
        errors.trustReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'Add Trust',
        old: '---',
        new: this.state.trust,
        reason: this.state.trustReason,
      });
    }
    if (this.state.powerOfAttorney) {
      if (!this.state.powerOfAttorneyReason) {
        errors.powerOfAttorneyReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'Add Power of Attorney',
        old: '---',
        new: this.state.powerOfAttorney,
        reason: this.state.powerOfAttorneyReason,
      });
    }
    if (this.state.other) {
      if (!this.state.otherReason) {
        errors.otherReasonError = 'Reason Not Selected';
      }
      changeList.push({
        condition: 'Other',
        old: '---',
        new: this.state.other,
        reason: this.state.otherReason,
      });
    }

    // if any errors render them in page
    if (Object.values(errors).length > 0) {
      this.setState({ errors });
      return;
    } else
      this.setState({
        errors,
        changesRequested: changeList,
        showConfirmModal: changeList.length > 0,
      });
  }

  ClearFields() {
    // clear loan info fields
    var statelist = {
      appraisedValue: '',
      creditScore: '',
      impound: '',
      loanAmount: '',
      pmi: '',
      occupancyType: '',
      loanProgram: '',
      propertyType: '',
      loanPurpose: '',
      purchasePrice: '',
      lockPeriod: '',
      propertyAddress: '',
      borrowers: '',
      trust: '',
      powerOfAttorney: '',
      other: '',

      appraisedValueReason: '',
      creditScoreReason: '',
      impoundReason: '',
      loanAmountReason: '',
      pmiReason: '',
      occupancyTypeReason: '',
      propertyTypeReason: '',
      loanPurposeReason: '',
      purchasePriceReason: '',
      lockPeriodReason: '',
      propertyAddressReason: '',
      borrowersReason: '',
      trustReason: '',
      powerOfAttorneyReason: '',
      otherReason: '',

      changesExist: false,
      changesRequested: [],
      newFeeRows: 0,
      showConfirmModal: false,
      sentNotifications: false,
      notificationError: false,
      retrievedData: false,
    };

    // clear auto-generated fields
    for (let i = 0; i < this.state.circumstanceData.feeData.length; i++) {
      const fee = this.state.circumstanceData.feeData[i];
      statelist[fee.feeID] = '';
      statelist[fee.feeID + 'Reason'] = '';
    }
    for (let i = 0; i < this.state.newFeeRows; i++) {
      statelist['newFeeDesc' + i] = '';
      statelist['newFeeAmt' + i] = '';
      statelist['newFee' + i + 'CB'] = null;
    }

    this.setState(statelist);
  }

  checkBoxClicked(targetName) {
    var checkedTest = this.state[targetName] ? this.state[targetName] : false;
    var fieldText = this.state[targetName.substr(3, targetName.length - 5)];
    this.setState({
      [targetName]: !checkedTest,
      [targetName.substr(3, targetName.length - 5)]: checkedTest
        ? fieldText === 'Request POC'
          ? ''
          : fieldText
        : fieldText
        ? fieldText
        : 'Request POC',
      changesExist: true,
    });
  }

  ShowChangeHistory() {
    if (this.state.circumstanceData.changes.length === 0) {
      return <></>;
    }
    return (
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th key="RequestDate">Requested</th>
              <th
                style={{
                  textAlign: 'center',
                  paddingRight: '20px',
                  paddingLeft: '10px',
                }}
                key="RequestBy"
              >
                By
              </th>
              <th key="Field">Field</th>
              <th style={{ textAlign: 'center' }} key="OldValue">
                Old Value
              </th>
              <th style={{ textAlign: 'center' }} key="NewValue">
                New Value
              </th>
              <th style={{ textAlign: 'center' }} key="Reason">
                Reason
              </th>
              <th style={{ textAlign: 'center' }} key="Status">
                <div className="dropdown">
                  <button
                    className="btn btn-link btn-sm dropdown-toggle p-0 fs-6 fw-bold text-black"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Status
                  </button>
                  <ul className="dropdown-menu">
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={this.toggleDenied}
                      >
                        {this.state.showDenied ? 'Hide denied' : 'Show denied'}
                      </button>
                    </li>
                  </ul>
                </div>
              </th>
              <th style={{ textAlign: 'center' }} key="UW">
                &nbsp;UW&nbsp;
              </th>
              <th style={{ textAlign: 'center' }} key="Comp">
                COMP
              </th>
              <th style={{ textAlign: 'center' }} key="Lock">
                LOCK
              </th>
              {LoginState.userOrg === '1000001' && (
                <th style={{ textAlign: 'center' }} key="ApproveDeny">
                  Actions
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {this.state.showDenied
              ? this.state.circumstanceData.changes.map(change =>
                  this.GetChangeRecord(
                    change.requestDateExact,
                    change.requestDate,
                    change.requestStatus,
                    change.changeRequested,
                    change.requestedBy,
                    change.deptStatus
                  )
                )
              : this.state.circumstanceData.changes
                  .filter(el => el.requestStatus !== 'Denied')
                  .map(change =>
                    this.GetChangeRecord(
                      change.requestDateExact,
                      change.requestDate,
                      change.requestStatus,
                      change.changeRequested,
                      change.requestedBy,
                      change.deptStatus
                    )
                  )}
          </tbody>
        </table>
      </div>
    );
  }

  toggleDenied = () => {
    this.setState({ showDenied: !this.state.showDenied });
  };

  GetChangeRecord(
    requestDateExact,
    requestDate,
    requestStatus,
    changeRequested,
    requestedBy,
    deptStatus
  ) {
    // note - I know the logic here looks strange, but this is to accomodate the old way the data was stored
    // which was later updated to split up each individual change rather than group them into one record.
    // then later on, we added another field for the change reason, so instead of 3 fields, we had 4.
    var changes = changeRequested.split('$$$$$');
    var contentToReturn = [];
    for (var i = 0; i < changes.length; i += 3) {
      contentToReturn.push(
        this.GetRecordRow(
          requestDateExact,
          requestDate,
          requestStatus,
          changes[i],
          changes[i + 1],
          changes[i + 2],
          changes.length > 4 || changes.length === 3 ? '---' : changes[i + 3],
          requestedBy,
          changeRequested,
          deptStatus
        )
      );
      if (changes.length === 4) break;
    }
    return <>{contentToReturn.map(content => content)}</>;
  }

  GetRecordRow(
    requestDateExact,
    requestDate,
    requestStatus,
    fieldName,
    oldValue,
    newValue,
    reason,
    requestedBy,
    changeRequested,
    deptStatus
  ) {
    var statusSplit = deptStatus.split(',');
    return (
      <tr key={requestDate + fieldName}>
        <td style={{ textAlign: 'center', paddingRight: '10px' }}>
          {requestDate.substr(0, 10)}
          <br />
          {requestDate.substr(11)}
        </td>
        <td
          style={{
            textAlign: 'center',
            paddingRight: '20px',
            paddingLeft: '10px',
          }}
        >
          {requestedBy}
        </td>
        <td>{fieldName}</td>
        <td style={{ textAlign: 'center', paddingRight: '10px' }}>
          {oldValue}
        </td>
        <td style={{ textAlign: 'center', paddingRight: '10px' }}>
          {newValue}
        </td>
        <td style={{ textAlign: 'center', paddingRight: '10px' }}>{reason}</td>
        <td style={{ textAlign: 'center' }}>
          <span
            className={`badge text-bg-${REVIEW_COLORS[requestStatus.trim()]}`}
          >
            {requestStatus}
          </span>
        </td>
        <td style={{ textAlign: 'center', minWidth: '60px' }}>
          {statusSplit[0] ? (
            statusSplit[0].endsWith('*') ? (
              <TinyTooltip
                tip={statusSplit[0].substr(0, statusSplit[0].length - 1)}
              >
                <i className="fs-5 bi bi-exclamation-triangle text-warning" />
              </TinyTooltip>
            ) : (
              <TinyTooltip tip={statusSplit[0]}>
                <i
                  className={`fs-5 bi bi-check-circle ${
                    requestStatus !== 'Denied'
                      ? 'text-success'
                      : 'text-secondary'
                  }`}
                />
              </TinyTooltip>
            )
          ) : (
            <>
              {this.isAdmin() && requestStatus !== 'Denied' ? (
                <>
                  <TinyTooltip tip="Admin Approve">
                    <i
                      class="bi bi-calendar2-check text-success"
                      style={{
                        fontSize: '15px',
                        marginRight: '5px',
                        cursor: 'pointer',
                      }}
                      onClick={() =>
                        this.UpdateCircumstance(
                          requestDateExact,
                          'Approved',
                          changeRequested,
                          'UwApproval'
                        )
                      }
                    />
                  </TinyTooltip>
                  <TinyTooltip tip="Admin Deny">
                    <i
                      class="bi bi-calendar-x text-danger"
                      style={{ fontSize: '15px', cursor: 'pointer' }}
                      onClick={() =>
                        this.UpdateCircumstance(
                          requestDateExact,
                          'Denied',
                          changeRequested,
                          'UwApproval'
                        )
                      }
                    />
                  </TinyTooltip>
                </>
              ) : (
                <i
                  className={`fs-5 bi bi-exclamation-triangle ${
                    requestStatus !== 'Denied' ? 'text-warning' : ''
                  }`}
                />
              )}
            </>
          )}
        </td>
        <td style={{ textAlign: 'center', minWidth: '60px' }}>
          {statusSplit[1] ? (
            statusSplit[1].endsWith('*') ? (
              <TinyTooltip
                tip={statusSplit[1].substr(0, statusSplit[1].length - 1)}
              >
                <i className="fs-5 bi bi-x-circle text-danger" />
              </TinyTooltip>
            ) : (
              <TinyTooltip tip={statusSplit[1]}>
                <i
                  className={`fs-5 bi bi-check-circle ${
                    requestStatus !== 'Denied'
                      ? 'text-success'
                      : 'text-secondary'
                  }`}
                />
              </TinyTooltip>
            )
          ) : (
            <>
              {this.isAdmin() && requestStatus !== 'Denied' ? (
                <>
                  <TinyTooltip tip="Admin Approve">
                    <i
                      class="bi bi-calendar2-check text-success"
                      style={{
                        fontSize: '15px',
                        marginRight: '5px',
                        cursor: 'pointer',
                      }}
                      onClick={() =>
                        this.UpdateCircumstance(
                          requestDateExact,
                          'Approved',
                          changeRequested,
                          'CompApproval'
                        )
                      }
                    />
                  </TinyTooltip>
                  <TinyTooltip tip="Admin Deny">
                    <i
                      class="bi bi-calendar-x text-danger"
                      style={{ fontSize: '15px', cursor: 'pointer' }}
                      onClick={() =>
                        this.UpdateCircumstance(
                          requestDateExact,
                          'Denied',
                          changeRequested,
                          'CompApproval'
                        )
                      }
                    />
                  </TinyTooltip>
                </>
              ) : (
                <i
                  className={`fs-5 bi bi-exclamation-triangle ${
                    requestStatus !== 'Denied' ? 'text-warning' : ''
                  }`}
                />
              )}
            </>
          )}
        </td>
        <td style={{ textAlign: 'center', minWidth: '60px' }}>
          {statusSplit[2] ? (
            statusSplit[2].endsWith('*') ? (
              <TinyTooltip
                tip={statusSplit[2].substr(0, statusSplit[2].length - 1)}
              >
                <i className="fs-5 bi bi-x-circle text-danger" />
              </TinyTooltip>
            ) : (
              <TinyTooltip tip={statusSplit[2]}>
                <i
                  className={`fs-5 bi bi-check-circle ${
                    requestStatus !== 'Denied'
                      ? 'text-success'
                      : 'text-secondary'
                  }`}
                />
              </TinyTooltip>
            )
          ) : (
            <>
              {this.isAdmin() && requestStatus !== 'Denied' ? (
                <>
                  <TinyTooltip tip="Admin Approve">
                    <i
                      class="bi bi-calendar2-check text-success"
                      style={{
                        fontSize: '15px',
                        marginRight: '5px',
                        cursor: 'pointer',
                      }}
                      onClick={() =>
                        this.UpdateCircumstance(
                          requestDateExact,
                          'Approved',
                          changeRequested,
                          'LockApproval'
                        )
                      }
                    />
                  </TinyTooltip>
                  <TinyTooltip tip="Admin Deny">
                    <i
                      class="bi bi-calendar-x text-danger"
                      style={{ fontSize: '15px', cursor: 'pointer' }}
                      onClick={() =>
                        this.UpdateCircumstance(
                          requestDateExact,
                          'Denied',
                          changeRequested,
                          'LockApproval'
                        )
                      }
                    />
                  </TinyTooltip>
                </>
              ) : (
                <i
                  className={`fs-5 bi bi-exclamation-triangle ${
                    requestStatus !== 'Denied' ? 'text-warning' : ''
                  }`}
                />
              )}
            </>
          )}
        </td>
        {LoginState.userOrg === '1000001' && (
          <>
            {requestStatus !== 'Denied' && this.enableButton(deptStatus) ? (
              <td style={{ textAlign: 'center', minWidth: '140px' }}>
                <button
                  className="btn btn-sm btn-outline-success me-2"
                  onClick={() =>
                    this.UpdateCircumstance(
                      requestDateExact,
                      'Approved',
                      changeRequested,
                      ''
                    )
                  }
                >
                  Approve
                </button>
                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() =>
                    this.UpdateCircumstance(
                      requestDateExact,
                      'Denied',
                      changeRequested,
                      ''
                    )
                  }
                >
                  Deny
                </button>
              </td>
            ) : (
              <td style={{ textAlign: 'center' }}>---</td>
            )}
          </>
        )}
      </tr>
    );
  }

  ShowLoanInformation() {
    const { errors } = this.state;
    return (
      <div className="row">
        {this.state.circumstanceData.changes.length > 0 && (
          <div className="col-12 pt-4">
            <p className="border-bottom text-muted text-uppercase">
              Change History
            </p>
            {this.ShowChangeHistory()}
          </div>
        )}
        <div className="col-12 pt-4">
          <p className="border-bottom text-uppercase text-muted mt-2 mb-4">
            Change Loan Information
          </p>
        </div>
        <div className="col-12">
          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">Appraisal Value</p>
              <span>{this.state.circumstanceData.appraisedValue}</span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <input
                type="text"
                className="form-control mb-2 me-md-2"
                onChange={this.captureInputCurrency}
                id="appraisedValue"
                value={this.state.appraisedValue}
                placeholder="$"
              />
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select w-100 mb-2"
                onChange={this.captureInput}
                id="appraisedValueReason"
                disabled={!this.state.appraisedValue}
                value={this.state.appraisedValueReason}
                error={errors && errors.appraisedValueReasonError}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.appraisedValueReasonError && (
                <p className="text-danger">
                  {errors.appraisedValueReasonError}
                </p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">Credit Score</p>
              <span>{this.state.circumstanceData.creditScore}</span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <input
                type="text"
                className="form-control mb-2 me-md-2"
                id="creditScore"
                onChange={this.captureInput}
                placeholder="Credit Score"
                value={this.state.creditScore}
              />
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select mb-2"
                onChange={this.captureInput}
                id="creditScoreReason"
                disabled={!this.state.creditScore}
                placeholder="Reason for CIC"
                value={this.state.creditScoreReason}
                error={errors && errors.creditScoreReasonError}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.creditScoreReasonError && (
                <p className="text-danger">{errors.creditScoreReasonError}</p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">Escrow Account</p>
              <span>
                {this.GetLabel(
                  this.state.circumstanceData.impound,
                  PRICING_OPTIONS.impound
                )}
              </span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <select
                className="form-select mb-2 me-md-2"
                onChange={this.captureInput}
                id="impound"
                value={this.state.impound}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.impound.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select mb-2"
                onChange={this.captureInput}
                id="impoundReason"
                disabled={!this.state.impound}
                placeholder="Reason for CIC"
                value={this.state.impoundReason}
                error={errors && errors.impoundReasonError}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.impoundReasonError && (
                <p className="text-danger">{errors.impoundReasonError}</p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">Loan Amount</p>
              <span>{this.state.circumstanceData.loanAmount}</span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <input
                type="text"
                className="form-control mb-2 me-md-2"
                onChange={this.captureInputCurrency}
                id="loanAmount"
                placeholder="Loan Amount"
                value={this.state.loanAmount}
              />
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select mb-2"
                onChange={this.captureInput}
                id="loanAmountReason"
                disabled={!this.state.loanAmount}
                placeholder="Reason for CIC"
                value={this.state.loanAmountReason}
                error={errors && errors.loanAmountReasonError}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.loanAmountReasonError && (
                <p className="text-danger">{errors.loanAmountReasonError}</p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">Mortgage Insurance</p>
              <span>
                {this.GetLabel(
                  this.state.circumstanceData.pmi,
                  PRICING_OPTIONS.pmi
                )}
              </span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <select
                className="form-select mb-2 me-md-2"
                onChange={this.captureInput}
                id="pmi"
                value={this.state.pmi}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.pmi.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select mb-2"
                onChange={this.captureInput}
                id="pmiReason"
                disabled={!this.state.pmi}
                placeholder="Reason for CIC"
                value={this.state.pmiReason}
                error={errors && errors.pmiReasonError}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.pmiReasonError && (
                <p className="text-danger">{errors.pmiReasonError}</p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">Occupancy Type</p>
              <span>{this.GetOccupancyType()}</span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <select
                className="form-select mb-2 me-md-2"
                onChange={this.captureInput}
                id="occupancyType"
                value={this.state.occupancyType}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.occupancyType.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select mb-2"
                onChange={this.captureInput}
                id="occupancyTypeReason"
                disabled={!this.state.occupancyType}
                placeholder="Reason for CIC"
                value={this.state.occupancyTypeReason}
                error={errors && errors.occupancyTypeReasonError}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.occupancyTypeReasonError && (
                <p className="text-danger">{errors.occupancyTypeReasonError}</p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">Loan Program / Term</p>
              <span>{this.state.circumstanceData.loanProgram}</span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <select
                className="form-select mb-2 me-md-2"
                onChange={this.captureInput}
                id="loanProgram"
                value={this.state.loanProgram}
              >
                <option value="-1">Select..</option>
                {this.state.circumstanceData.programs.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select mb-2"
                onChange={this.captureInput}
                id="loanProgramReason"
                disabled={!this.state.loanProgram}
                placeholder="Reason for CIC"
                value={this.state.loanProgramReason}
                error={errors && errors.loanProgramReasonError}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.loanProgramReasonError && (
                <p className="text-danger">{errors.loanProgramReasonError}</p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">Property Type</p>
              <span>{this.GetPropertyType()}</span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <select
                className="form-select mb-2 me-md-2"
                onChange={this.captureInput}
                id="propertyType"
                value={this.state.propertyType}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.propertyType.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select mb-2"
                onChange={this.captureInput}
                id="propertyTypeReason"
                disabled={!this.state.propertyType}
                placeholder="Reason for CIC"
                value={this.state.propertyTypeReason}
                error={errors && errors.propertyTypeReasonError}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.propertyTypeReasonError && (
                <p className="text-danger">{errors.propertyTypeReasonError}</p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">Loan Purpose</p>
              <span>{this.state.circumstanceData.loanPurpose}</span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <select
                className="form-select mb-2 me-md-2"
                onChange={this.captureInput}
                id="loanPurpose"
                value={this.state.loanPurpose}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.loanPurpose.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select mb-2"
                onChange={this.captureInput}
                id="loanPurposeReason"
                disabled={!this.state.loanPurpose}
                placeholder="Reason for CIC"
                value={this.state.loanPurposeReason}
                error={errors && errors.loanPurposeReasonError}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.loanPurposeReasonError && (
                <p className="text-danger">{errors.loanPurposeReasonError}</p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">Purchase Price</p>
              <span>{this.state.circumstanceData.purchasePrice}</span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <input
                type="text"
                className="form-control mb-2 me-md-2"
                onChange={this.captureInputCurrency}
                id="purchasePrice"
                placeholder="Purchase Price"
                value={this.state.purchasePrice}
              />
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select mb-2"
                onChange={this.captureInput}
                id="purchasePriceReason"
                disabled={!this.state.purchasePrice}
                placeholder="Reason for CIC"
                value={this.state.purchasePriceReason}
                error={errors && errors.purchasePriceReasonError}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.purchasePriceReasonError && (
                <p className="text-danger">{errors.purchasePriceReasonError}</p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">Lock Days</p>
              <span>{this.state.circumstanceData.lockDays !== "-1" ? PRICING_OPTIONS.lockPeriod[this.state.circumstanceData.lockDays].label : "---"}</span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <select
                className="form-select mb-2 me-md-2"
                onChange={this.captureInput}
                id="lockDays"
                value={this.state.lockDays}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.lockPeriod.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select mb-2"
                onChange={this.captureInput}
                id="lockDaysReason"
                disabled={!this.state.lockDays}
                placeholder="Reason for CIC"
                value={this.state.lockDaysReason}
                error={errors && errors.lockDaysReasonError}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.lockDaysReasonError && (
                <p className="text-danger">{errors.lockDaysReasonError}</p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">Lock Extension</p>
              <span>{this.state.circumstanceData.lockExpirationDate}</span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <select
                className="form-select mb-2 me-md-2"
                onChange={this.captureInput}
                id="lockExtension"
                value={this.state.lockExtension}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.lockExtension.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select mb-2"
                onChange={this.captureInput}
                id="lockExtensionReason"
                disabled={!this.state.lockExtension}
                placeholder="Reason for CIC"
                value={this.state.lockExtensionReason}
                error={errors && errors.lockExtensionReasonError}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.lockExtensionReasonError && (
                <p className="text-danger">{errors.lockExtensionReasonError}</p>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">P&L Preparer</p>
              <span>{this.state.circumstanceData.pnlPreparer}</span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <select
                className="form-select mb-2 me-md-2"
                onChange={this.captureInput}
                id="pnlPreparer"
                value={this.state.pnlPreparer}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.pnlPreparer.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select mb-2"
                onChange={this.captureInput}
                id="pnlPreparerReason"
                disabled={!this.state.pnlPreparer}
                placeholder="Reason for CIC"
                value={this.state.pnlPreparerReason}
                error={errors && errors.pnlPreparerReasonError}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.pnlPreparerReasonError && (
                <p className="text-danger">{errors.pnlPreparerReasonError}</p>
              )}
            </div>
          </div>

          {this.state.circumstanceData.loanProgram.includes('Portfolio 2') &&
            this.state.circumstanceData.occupancyType === 3 && (
              <div className="row">
                <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
                  <p className="mb-0">Prepayment Penalty</p>
                  <span>
                    {this.state.circumstanceData.prepaymentPenalty === '---'
                      ? 'No Prepay Penalty'
                      : Number(this.state.circumstanceData.prepaymentPenalty) /
                          12 +
                        '-Year Prepay Penalty'}
                  </span>
                </div>
                <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
                  <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
                  <i className="text-success bi bi-arrow-down d-md-none"></i>
                </div>
                <div className="col-12 col-md-4">
                  <select
                    className="form-select mb-2 me-md-2"
                    onChange={this.captureInput}
                    id="prepaymentPenalty"
                    value={this.state.prepaymentPenalty}
                  >
                    <option value="-1">Select..</option>
                    {PRICING_OPTIONS.prepayPenalty.map(el => (
                      <option key={el.value} value={el.value}>
                        {el.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-12 col-md-3">
                  <select
                    className="form-select mb-2"
                    onChange={this.captureInput}
                    id="prepaymentPenaltyReason"
                    disabled={!this.state.prepaymentPenalty}
                    placeholder="Reason for CIC"
                    value={this.state.prepaymentPenaltyReason}
                    error={errors && errors.prepaymentPenaltyReasonError}
                  >
                    <option value="-1">Select..</option>
                    {PRICING_OPTIONS.cocReasons.map(el => (
                      <option key={el.value} value={el.value}>
                        {el.label}
                      </option>
                    ))}
                  </select>
                  {errors.prepaymentPenaltyReasonError && (
                    <p className="text-danger">
                      {errors.prepaymentPenaltyReasonError}
                    </p>
                  )}
                </div>
              </div>
            )}
          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">Property Address</p>
              <span style={{ whiteSpace: 'pre-wrap', textAlign: 'right' }}>
                {this.state.circumstanceData.propertyAddress}
              </span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <input
                type="text"
                className="form-control mb-2 me-md-2"
                onChange={this.captureInput}
                id="propertyAddress"
                placeholder="Property Address"
                value={this.state.propertyAddress}
              />
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select mb-2"
                onChange={this.captureInput}
                id="propertyAddressReason"
                disabled={!this.state.propertyAddress}
                placeholder="Reason for CIC"
                value={this.state.propertyAddressReason}
                error={errors && errors.propertyAddressReasonError}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.propertyAddressReasonError && (
                <p className="text-danger">
                  {errors.propertyAddressReasonError}
                </p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">Add/Remove Borrower</p>
              <span style={{ whiteSpace: 'pre-wrap', textAlign: 'right' }}>
                {this.state.circumstanceData.borrowers}
              </span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <input
                type="text"
                className="form-control mb-2 me-md-2"
                onChange={this.captureInput}
                id="borrowers"
                placeholder="Borrower"
                value={this.state.borrowers}
              />
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select mb-2"
                onChange={this.captureInput}
                id="borrowersReason"
                disabled={!this.state.borrowers}
                placeholder="Reason for CIC"
                value={this.state.borrowersReason}
                error={errors && errors.borrowersReasonError}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.borrowersReasonError && (
                <p className="text-danger">{errors.borrowersReasonError}</p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">Add Trust</p>
              <span>---</span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <input
                type="text"
                className="form-control mb-2 me-md-2"
                onChange={this.captureInput}
                id="trust"
                value={this.state.trust}
                placeholder="Add Trust"
              />
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select mb-2"
                onChange={this.captureInput}
                id="trustReason"
                disabled={!this.state.trust}
                placeholder="Reason for CIC"
                value={this.state.trustReason}
                error={errors && errors.trustReasonError}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.trustReasonError && (
                <p className="text-danger">{errors.trustReasonError}</p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">Add Power of Attorney</p>
              <span>---</span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <input
                type="text"
                className="form-control mb-2 me-md-2"
                onChange={this.captureInput}
                id="powerOfAttorney"
                placeholder="Power of Attorney"
                value={this.state.powerOfAttorney}
              />
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select mb-2"
                onChange={this.captureInput}
                id="powerOfAttorneyReason"
                disabled={!this.state.powerOfAttorney}
                placeholder="Reason for CIC"
                value={this.state.powerOfAttorneyReason}
                error={errors && errors.powerOfAttorneyReasonError}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.powerOfAttorneyReasonError && (
                <p className="text-danger">
                  {errors.powerOfAttorneyReasonError}
                </p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4 d-flex justify-content-between align-items-center">
              <p className="mb-0">Other</p>
              <span>---</span>
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
              <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
              <i className="text-success bi bi-arrow-down d-md-none"></i>
            </div>
            <div className="col-12 col-md-4">
              <input
                type="text"
                className="form-control mb-2 me-md-2"
                id="other"
                onChange={this.captureInput}
                value={this.state.other}
                placeholder="Other"
              />
            </div>
            <div className="col-12 col-md-3">
              <select
                className="form-select mb-2"
                onChange={this.captureInput}
                id="otherReason"
                disabled={!this.state.other}
                placeholder="Reason for CIC"
                value={this.state.otherReason || -1}
              >
                <option value="-1">Select..</option>
                {PRICING_OPTIONS.cocReasons.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
              {errors.otherReasonError && (
                <p className="text-danger">{errors.otherReasonError}</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-12 mt-3 text-end">
          <button
            className="btn btn-primary"
            disabled={!this.state.changesExist}
            onClick={() => this.CheckAndSubmitLoanInfoChanges()}
          >
            Review Changes
          </button>
        </div>
        <Modal
          title="Confirm Changes"
          show={this.state.showConfirmModal}
          onAccept={() => this.SendChangeNotifications()}
          onDecline={() => this.setState({ showConfirmModal: false })}
          buttonMessage="Submit"
        >
          {this.ShowConfirmModal()}
        </Modal>
      </div>
    );
  }

  ShowFees() {
    const { errors } = this.state;
    let currency = Intl.NumberFormat('en-US');
    return (
      <div className="row">
        {this.state.circumstanceData.changes &&
          this.state.circumstanceData.changes.length > 0 && (
            <div className="col-12 pt-4">
              <p className="border-bottom text-muted text-uppercase">
                Change History
              </p>
              {this.ShowChangeHistory()}
            </div>
          )}
        <div className="col-12 pt-4">
          <p className="border-bottom text-muted text-uppercase mt-2 mb-4">
            Change Fee Information
          </p>
          <small>Request POC</small>
          {this.state.circumstanceData.feeData.map(fee => (
            <React.Fragment>
              {(fee.description !== 'Loan Discount Points' || LoginState.userRole.toLowerCase().includes('lock')) && (
                <div className="row" key={fee.feeID}>
                  <div className="col-12 col-md-3 d-flex justify-content-between align-items-center">
                    <p className="mb-0">{fee.description}</p>
                    <span>
                      {'$' + currency.format(parseFloat(fee.amount).toFixed(2))}
                    </span>
                  </div>
                  <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
                    <i className="text-success bi bi-arrow-right d-none d-md-block"></i>
                    <i className="text-success bi bi-arrow-down d-md-none"></i>
                  </div>
                  <div className="col-12 col-md-3 mb-2">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Amount"
                      onChange={this.captureInputCurrency}
                      id={fee.feeID}
                      key={fee.feeID}
                      value={this.state[fee.feeID] || ''}
                    />
                  </div>
                  <div className="col-12 col-md-3 mb-2">
                    <select
                      className="form-select"
                      onChange={this.captureInput}
                      id={fee.feeID + 'Reason'}
                      disabled={!this.state[fee.feeID]}
                      placeholder="Reason for CIC"
                      value={this.state[fee.feeID + 'Reason']}
                    >
                      <option value="-1">Select..</option>
                      {PRICING_OPTIONS.cocReasons.map(el => (
                        <option key={el.value} value={el.value}>
                          {el.label}
                        </option>
                      ))}
                    </select>
                    {errors[fee.feeID + 'ReasonError'] && (
                      <p className="text-danger">
                        {errors[fee.feeID + 'ReasonError']}
                      </p>
                    )}
                  </div>
                  <div className="col-12 col-md-2">
                    <div className="form-check mb-3 mb-md-0 mt-md-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={'fee' + fee.feeID + 'CB'}
                        checked={this.state['fee' + fee.feeID + 'CB'] || false}
                        onChange={() =>
                          this.checkBoxClicked('fee' + fee.feeID + 'CB')
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={'fee' + fee.feeID + 'CB'}
                      >
                        Request POC
                      </label>
                    </div>
                  </div>
                </div>
              )}
            </React.Fragment>
          ))}
          {this.state.newFeeRows > 0 && (
            <div className="col-12">
              {Array.from(Array(this.state.newFeeRows)).map(
                (TableRow, index) => (
                  <div key={index} className="row border-top pt-4 pt-md-3">
                    <div className="col-12 col-md-4 d-flex flex-col flex-md-row align-items-center">
                      <button
                        className="btn btn-sm btn-light"
                        onClick={() => this.RemoveFeeRow(index)}
                      >
                        <i className="bi bi-trash3"></i>
                      </button>
                      <p className="text-center mb-0 ms-2">
                        New Fee #{index + 1}
                      </p>
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <input
                        className="form-control"
                        placeholder="Description"
                        onChange={this.captureInput}
                        id={'newFeeDesc' + index}
                        key={'newFeeDesc' + index}
                        value={this.state['newFeeDesc' + index] || ''}
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <input
                        className="form-control"
                        placeholder="Amount"
                        onChange={this.captureInputCurrency}
                        id={'newFeeAmt' + index}
                        key={'newFeeAmt' + index}
                        value={this.state['newFeeAmt' + index] || ''}
                      />
                    </div>
                    <div className="col-12 col-md-2">
                      <div className="form-check mb-3 mb-md-0 mt-md-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={'newFee' + index + 'CB'}
                          checked={this.state['newFee' + index + 'CB'] || false}
                          onChange={() =>
                            this.checkBoxClicked('newFee' + index + 'CB')
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={'newFee' + index + 'CB'}
                        >
                          Request POC
                        </label>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          )}
          {this.state.newFeeRows > 0 && <hr />}
          <div className="mt-2 d-flex justify-content-between">
            <button
              className="btn btn-outline-primary"
              onClick={() => this.AddFeeRow()}
            >
              Add New &nbsp;{' '}
              <i className="bi bi-plus" style={{ fontSize: '1rem' }}></i>
            </button>
            <button
              className="btn btn-primary"
              disabled={!this.state.changesExist}
              onClick={() => this.CheckAndSubmitFeeChanges()}
            >
              Review Changes
            </button>
          </div>
        </div>
        <Modal
          title="Confirm Changes"
          show={this.state.showConfirmModal}
          onAccept={() => this.SendChangeNotifications()}
          onDecline={() => this.setState({ showConfirmModal: false })}
          buttonMessage="Submit"
        >
          {this.ShowConfirmModal()}
        </Modal>
      </div>
    );
  }

  renderContent = () => {
    const { retrievedData, showFees } = this.state;
    if (!retrievedData) {
      return (
        <div style={{ width: '100%', textAlign: 'center' }}>
          <img src="/images/spinner.gif" alt="" height="64px" width="64px" />
        </div>
      );
    }
    return showFees ? this.ShowFees() : this.ShowLoanInformation();
  };

  enableButton(deptStatus) {
    var { circumstanceData } = this.state;
    var splitStatus = deptStatus.split(',');
    var userName = LoginState.userName;
    return (
      (userName === circumstanceData.underwriter && !splitStatus[0]) ||
      (userName === circumstanceData.underwriter2 && !splitStatus[0]) ||
      (userName === circumstanceData.compliance && !splitStatus[1]) ||
      (userName === circumstanceData.lockDesk && !splitStatus[2])
    );
  }

  isAdmin() {
    return LoginState.userRole.toLowerCase().includes('admin');
  }

  render() {
    const { showFees } = this.state;
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1 className="h4 text-uppercase">
              change in circumstances
              <button
                className="btn btn-text dropdown-toggle"
                style={{ marginLeft: '5px' }}
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="bi bi-list"></i>
              </button>
              <ul className="dropdown-menu">
                <li>
                  <p className="dropdown-item mb-0 disabled">Recent Files</p>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                {this.state.searchLog.length > 0 ? (
                  <>
                    {this.state.searchLog.map(file => (
                      <li key={file.encodedFileID}>
                        <span
                          className="dropdown-item"
                          onClick={() => {
                            this.props.history.push(
                              '/pipeline/change-in-circumstance/' +
                                file.encodedFileID
                            );
                            this.PageLoad(file.encodedFileID);
                          }}
                        >
                          {file.encodedFileID} ({file.borrower})
                        </span>
                      </li>
                    ))}
                  </>
                ) : (
                  <li>
                    <p className="dropdown-item mb-0 disabled">
                      No Recent Files
                    </p>
                  </li>
                )}
              </ul>
            </h1>
          </div>
          <div className="col-12">
            <ul className="nav nav-tabs nav-fill">
              <li className="nav-item" style={{ cursor: 'pointer' }}>
                <span
                  className={`nav-link ${!showFees ? 'active' : ''}`}
                  onClick={() => this.setState({ showFees: false })}
                  aria-current="page"
                  href="#"
                >
                  Loan Information Changes
                </span>
              </li>
              <li className="nav-item" style={{ cursor: 'pointer' }}>
                <span
                  className={`nav-link ${showFees ? 'active' : ''}`}
                  onClick={() => this.setState({ showFees: true })}
                  href="#"
                >
                  Fee Changes
                </span>
              </li>
            </ul>
            <div style={{padding:'15px', background: 'white', borderLeft: '1px solid #e0e0e0', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0'}}>{this.renderContent()}</div>
            <ModalWait
              title="Uploading Changes. Please Wait!"
              show={this.state.isUploading}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Circumstance);
